<template>
  <div>
    <v-btn
      @click="handleClick"
      size="small"
      variant="flat"
      :text="xs && iconXS ? null : value"
      :prepend-icon="iconXS"
      :disabled="disableBtn"
      />

    <v-dialog
      v-model="isActive"
      :max-width="maxWidth"
      :fullscreen="xs"
      scrollable
      @click:outside="handleClose"
    >
      <v-card class="rd">
        <div v-if="title" class="rd__head">
          <span class="rd__title">{{ $filters.capitalize(title) }}</span>
          <v-btn icon="mdi-close" variant="text" density="comfortable" @click="handleClose" :aria-label="$t('close')" />
        </div>
        <v-card-text class="rd__body">
          <slot name="content" v-bind="$props" />
        </v-card-text>
        <v-card-actions class="rd__actions">
          <v-spacer></v-spacer>
          <v-btn variant="text" :text="$t('close')" @click="handleClose"></v-btn>
          <v-btn v-if="withSave" color="primary" variant="flat" :text="$t('save')" @click="handleSave"></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { useDisplay } from "vuetify";

  export default {
    props: {
      value: {
        type: String,
        required: false,
      },
      // shown as a header with a close button; leave empty when the content has its own header
      title: {
        type: String,
        required: false,
        default: '',
      },
      iconXS: {
        type: String,
        required: false,
      },
      disableBtn: {
        type: Boolean,
        required: false,
        default: false,
      },
      withSave: {
        type: Boolean,
        required: false,
        default: false,
      },
      maxWidth: {
        type: [Number, String],
        required: false,
        default: 720,
      },
    },
    // content components with their own header close through this
    provide() {
      return { dialogClose: this.handleClose }
    },
    computed: {
      xs() {
        return useDisplay().xs.value
      },
    },
    data() {
      return {
        isActive: false
      };
    },
    methods: {
      handleClick() {
        this.isActive = true
        this.$emit('click');
      },
      handleClose() {
        this.isActive = false;
        this.$emit('close');
      },
      handleSave(){
        this.$emit('save')
        this.isActive = false;
      },
    },
  };
</script>

<style scoped>
.rd {
  display: flex;
  flex-direction: column;
}
.rd__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 8px 10px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.rd__title {
  flex: 1 1 auto;
  min-width: 0;
  font-weight: 700;
  font-size: 1.05rem;
}
.rd__body {
  padding: 12px 16px;
}
.rd__actions {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding: 8px 12px;
}
</style>
